import { CapaciteEditStepEnum } from './constants/capacite-edit-step.enum';
import { CapaciteStepEnum } from './constants/capacite-step.enum';
import { TypeProprieteEnum } from './constants/type-propriete.enum';
import { CapaciteModel, CapacitePartial } from './modeles/capacite.model';
import { DepenseResidenceModel } from './modeles/depense-residence.model';

export class ChargerCapacite {
  static type = '[Capacite] ChargerCapacite';
}

export class ModifierCapacite {
  static type = '[Capacite] ModifierCapacite';
  constructor(public morceauCapacite: CapacitePartial) {}
}

export class GoNextStep {
  static type = '[Capacite] GoNextStep';
  constructor(public route = null) {}
}

export class GoPreviousStep {
  static type = '[Capacite] GoPreviousStep';
}

export class GoToStep {
  static type = '[Capacite] GoToStep';
  constructor(public step: CapaciteStepEnum) {}
}

export class NavigatePageNonEligible {
  static type = '[Capacite] NavigatePageNonEligible';
}

export class NavigatePageAccueil {
  static type = '[Capacite] NavigatePageAccueil';
}

export class NavigatePageFormulaire {
  static type = '[Capacite] NavigatePageFormulaire';
}

export class NavigatePageResultat {
  static type = '[Capacite] NavigatePageResultat';
  constructor(public isConfirmationVisble?: boolean) {}
}

export class NavigatePageModification {
  static type = '[Capacite] NavigatePageModification';
  constructor(public step: CapaciteEditStepEnum) {}
}

export class SaveStepBudget {
  static type = '[Capacite] SaveStepBudget';
  constructor(public morceauCapacite: Partial<CapaciteModel>) {}
}

export class SaveStepHypotheque {
  static type = '[Capacite] SaveStepHypotheque';
  public morceauCapacite: CapacitePartial;
  constructor(depensesResidenceCourante: DepenseResidenceModel) {
    this.morceauCapacite = { depensesResidenceCourante };
  }
}

export class SaveStepDettes {
  static type = '[Capacite] SaveStepDettes';
  constructor(public morceauCapacite: CapacitePartial) {}
}

export class SaveStepDepensesTotales {
  static type = '[Capacite] SaveStepDepensesTotales';
  constructor(public morceauCapacite: Partial<CapaciteModel>) {}
}
export class SaveStepPaiement {
  static type = '[Capacite] SaveStepPaiement';
  constructor(public morceauCapacite: Partial<CapaciteModel>) {}
}

export class SaveStepDepenses {
  static type = '[Capacite] SaveStepDepenses';
  constructor(public morceauCapacite: Partial<CapaciteModel>) {}
}

export class SaveStepQuestionTypePropriete {
  static type = '[Capacite] SaveStepQuestionTypePropriete';
  constructor(public typePropriete: TypeProprieteEnum) {}
}

export class PersistPendingChanges {
  static type = '[Capacite] PersistPendingChanges';

  constructor(public morceauCapacite: CapacitePartial) {}
}

export class CalculerCapacite {
  static type = '[Capacite] CalculerCapacite';

  constructor(public morceauCapacite: CapacitePartial) {}
}

export class CalculerCapaciteSuccess {
  static type = '[Capacite] CalculerCapaciteSuccess';

  constructor(public capacite: CapaciteModel) {}
}

export class CalculerCapaciteFailed {
  static type = '[Capacite] CalculerCapaciteFailed';
}

export class CalculerScenarioCapacite {
  static type = '[Capacite] CalculerScenarioCapacite';

  constructor(public morceauCapacite: CapacitePartial) {}
}

export class ClearScenarioCapacite {
  static type = '[Capacite] ClearScenarioCapacite';
}

export class PatchCapaciteDebugOnly {
  static type = '[Capacite] PatchCapaciteDebugOnly';

  constructor(public capacite: Partial<CapaciteModel>, public isCompleted: boolean) {}
}
